import React, { useEffect, useState } from "react";
import { NavWrapper, StyledSidebar } from "components/atoms/SideBar/Sidebar.styles";
import AsideSelect from "components/atoms/SideBar/SubMenu";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { navData } from "components/atoms/Constant";
import logo from "assets/foodie-logo.png";
import collapsedLogo from "assets/collapsed-logo.png";
import chef from "assets/Aside/chef.svg";
import toggle_icon from "assets/Aside/toggle-icon.svg";
import Button from "components/molecules/Button";
import AddMenu from "components/atoms/MenuManagement/AddMenu";
import ModalContainer from "components/molecules/ModalContainer";
import { useAuthContext } from "Context/authContext";

const SideBar = () => {
  const { allowedPages } = useAuthContext();
  const navigate = useNavigate();

  const location = useLocation();
  const { pathname } = location;
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [filterNav, setFilterNav] = useState(navData);

  const handleToggle = () => {
    if (isCollapsed) {
      document.body.classList.add("collapsed");
    } else {
      document.body.classList.remove("collapsed");
    }
    setIsCollapsed(!isCollapsed);
  };

  const handleItemClick = () => {
  //  if (isCollapsed) {
  //     document.body.classList.add("collapsed");
  //   } else {
      document.body.classList.remove("collapsed");
    // }
    setIsCollapsed(true);
  };

  const handleSubMenuClick = (elem) => {
    // If sidebar is collapsed, navigate to first submenu item (don't expand sidebar)
    if (isCollapsed && elem?.subMenu && elem.subMenu.length > 0) {
      // Navigate to first submenu item
      navigate(elem.subMenu[0].route);
    }
  };
  useEffect(() => {
    // If allowedPages is empty or undefined, show all navigation items as fallback
    if(isCollapsed){
                  document.body.classList.remove("collapsed");

    }
    if (!allowedPages || allowedPages.length === 0) {
      setFilterNav(navData);
    } else {
      const filteredNav = navData.filter((item) => allowedPages.includes(item?.permissionRoute));
      setFilterNav(filteredNav);
    }
  }, [allowedPages]);

  return (
    <StyledSidebar isCollapsed={isCollapsed}>
      <div className="toggle-icon" onClick={handleToggle}>
        <img src={toggle_icon} alt="toggle-icon" />
      </div>
      <NavWrapper>
        <ul>
          <div className="foodie-logo-wrapper">
            {!isCollapsed ? (
              <img src={logo} alt="logo" />
            ) : (
              <img src={collapsedLogo} alt="logo" />
            )}
          </div>
          {filterNav.map((elem, ind) => 
            elem.route ? (
              <Link to={elem.route} key={ind}>
                <li
                  className={`linkItems ${pathname === elem.route && "active active-border"
                    } ${isCollapsed && "collapsed"}`}
                  onClick={handleItemClick}
                >
                  <img src={elem.icon} alt="icon" />
                  {!isCollapsed && (
                    <NavLink to={elem.route} style={{ whiteSpace: "nowrap" }}>
                      {elem.name}
                    </NavLink>
                  )}
                </li>
              </Link>
            ) : (
              <li
                key={ind}
                className={`subLinkItems ${pathname.includes(elem.fakeRoute) ? "active" : ""
                  }`}
                onClick={() => handleSubMenuClick(elem)}
              >
                <AsideSelect
                  icon={elem.icon}
                  type
                  title={elem.name}
                  option={elem?.subMenu}
                  active={pathname.includes(elem.fakeRoute)}
                  isCollapsed={isCollapsed}
                  onClick={handleItemClick}
                />
              </li>
            )
          )}
        </ul>
      </NavWrapper>
      {!isCollapsed && (
        <div className="add-menus">
          <img src={chef} alt="chef" />
          <p>Organize your menus through the button below</p>
          <ModalContainer
            width={600}
            title="Add Menu"
            btnComponent={({ onClick }) => (
              <Button onClick={onClick}>+ Add Menus</Button>
            )}
            content={({ onClose }) => <AddMenu onClose={onClose} />}
          />
        </div>
      )}
    </StyledSidebar>
  );
};

export default SideBar;
